/* ============================================================
   MOZIGO — Cart drawer bridge cho Teeinblue ATC
   ============================================================ */
(function () {
  if (!window.Shopify) return;

  var prev = window.Shopify.onItemAdded;
  window.Shopify.onItemAdded = function (item) {
    if (typeof prev === 'function') {
      try { prev(item); } catch (e) {}
    }
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  };
})();

/* ============================================================
   MOZIGO — Giữ Teeinblue widget sống sau khi Prestige thay
   thế <buy-buttons> khi đổi variant.

   Root cause: Prestige gọi buy-buttons.replaceWith(newEl) →
   element cũ (cùng với widget Teeinblue bên trong) bị xoá khỏi
   DOM → widget mất.  Teeinblue không tự inject lại vì init của
   nó chỉ chạy 1 lần lúc page load.

   Fix: override phương thức replaceWith() trên chính instance
   buy-buttons.  Khi bị gọi, ta CHUYỂN (không clone) node
   .teeinblue-widget sang element mới trước khi DOM cũ bị xoá
   → widget sống nguyên với toàn bộ event listener / framework
   state.  Sau đó gọi setVariantId() để Teeinblue cập nhật UI
   cho variant mới.
   ============================================================ */
(function () {
  var TEE_WIDGET = '.teeinblue-widget';
  var BLOCK_SEL  = '[data-block-type="buy-buttons"]';

  /* Đọc variant ID hiện tại từ URL hoặc form hidden input */
  function getCurrentVariantId() {
    var v = new URLSearchParams(window.location.search).get('variant');
    if (v) return parseInt(v, 10);
    var input = document.querySelector('product-form form input[name="id"]');
    return input ? parseInt(input.value, 10) : null;
  }

  /* Báo cho Teeinblue biết variant mới */
  function notifyTeeinblue() {
    if (!window.teeinblue) return;
    try {
      var id = getCurrentVariantId();
      if (id && typeof window.teeinblue.setVariantId === 'function') {
        window.teeinblue.setVariantId(id);
      }
    } catch (e) {}
  }

  /* Patch replaceWith() trên một <buy-buttons> element */
  function patchBuyButtons(bb) {
    if (bb._teePatched) return;
    bb._teePatched = true;

    var _nativeReplaceWith = bb.replaceWith;

    bb.replaceWith = function () {
      var oldBb  = this;
      var widget = oldBb.querySelector(TEE_WIDGET);

      _nativeReplaceWith.apply(oldBb, arguments);

      if (!(arguments[0] instanceof Element)) return;
      var newBb = arguments[0];
      patchBuyButtons(newBb); /* Patch lại cho lần đổi variant tiếp */

      if (widget) {
        /* Happy path: widget đã có → chuyển sang element mới */
        if (widget.parentElement !== newBb) newBb.appendChild(widget);
        setTimeout(notifyTeeinblue, 100);
      } else {
        /* Race condition: Teeinblue chưa inject kịp trước khi replaceWith chạy.
           Theo dõi cả oldBb (detached) lẫn newBb (live) — hễ widget xuất hiện
           ở đâu thì chuyển ngay sang newBb. */
        var moved = false;

        function tryMove(source) {
          if (moved) return;
          var w = source.querySelector(TEE_WIDGET);
          if (!w) return;
          moved = true;
          obs1.disconnect();
          obs2.disconnect();
          if (w.parentElement !== newBb) newBb.appendChild(w);
          setTimeout(notifyTeeinblue, 100);
        }

        var obs1 = new MutationObserver(function () { tryMove(oldBb); });
        var obs2 = new MutationObserver(function () { tryMove(newBb); });
        obs1.observe(oldBb, { childList: true, subtree: true });
        obs2.observe(newBb, { childList: true, subtree: true });

        /* Sau 4s: widget không inject vào old/new main bb (có thể ở sticky bar).
           Tìm widget bất kỳ đâu trong DOM, move sang main buy-buttons hiện tại,
           rồi gọi setVariantId để Teeinblue re-check design sau khi đã init xong. */
        setTimeout(function () {
          obs1.disconnect();
          obs2.disconnect();
          if (moved) return;
          var w = document.querySelector(TEE_WIDGET);
          if (w) {
            var rerender = document.querySelector('product-rerender');
            var currentBb = rerender ? rerender.querySelector('buy-buttons') : newBb;
            if (currentBb && w.parentElement !== currentBb) {
              currentBb.appendChild(w);
            }
          }
          notifyTeeinblue();
        }, 4000);
      }
    };
  }

  /* Last-resort: nếu sau 5s Teeinblue Vue vẫn không add tee-form-wrapper
     (Vue init thất bại một phần), ta force show bằng cách:
     1. Xóa inline style="display:none" trên widget
     2. Thêm tee-form-wrapper để CSS ẩn native ATC hoạt động đúng
     Chỉ áp dụng khi widget nằm trong main product-rerender, không phải sticky bar. */
  function forceTeeinblueVisible() {
    var w = document.querySelector(TEE_WIDGET);
    if (!w) return;

    var bb = w.closest('buy-buttons');
    if (!bb) return;
    if (bb.classList.contains('tee-form-wrapper')) return; /* đã init xong rồi */
    if (!w.closest('product-rerender')) return;
    if (w.closest('product-sticky-bar')) return;

    bb.classList.add('tee-form-wrapper');
    w.style.removeProperty('display');
  }

  function init() {
    /* Patch tất cả buy-buttons có mặt lúc init */
    document.querySelectorAll('buy-buttons').forEach(patchBuyButtons);

    /* Safety-net: nếu buy-buttons xuất hiện SAU init (hiếm) cũng được patch */
    document.querySelectorAll(BLOCK_SEL).forEach(function (block) {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          m.addedNodes.forEach(function (node) {
            if (node.nodeName && node.nodeName.toLowerCase() === 'buy-buttons') {
              patchBuyButtons(node);
            }
          });
        });
      }).observe(block, { childList: true });
    });

    /* Fallback: force show sau 5s nếu Teeinblue Vue không tự complete */
    setTimeout(forceTeeinblueVisible, 5000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
